import { Link } from "react-router-dom";

import { data, desde } from "../api.ts";
import { Cartao, MicroMedidor, Selo, Vazio } from "../componentes/basicos.tsx";
import { useDados } from "../usarDados.ts";

type Visao = {
  tiles: { valor: number; rotulo: string; sub: string; alerta?: boolean }[];
  linhas: {
    licenca_id: number; empresa: string; apelido: string;
    vagas_usadas: number; vagas_total: number;
    instancias_pico: number; instancias_total: number;
    pico_historico: number; dia_do_pico: string | null;
    validade: string | null; modo_offline: string;
    ultimo_sinal: string | null; folga: number;
  }[];
};

/**
 * Uso real contra o contratado, uma linha por licenca ativa.
 *
 * E a lista que se leva para uma ligacao de renovacao: o painel mostra o
 * agregado, esta mostra os nomes. Ordenada pela ocupacao mais apertada
 * primeiro -- quem esta acima do contrato no topo.
 *
 * O vocabulario e sempre "X de Y", com o CONTRATO no denominador. Nunca
 * percentual sozinho, nunca contagem sozinha.
 */
export function Uso() {
  const { dados: v, erro, carregando } = useDados<Visao>("/uso");

  if (carregando) return <div className="carregando">carregando...</div>;
  if (erro || !v) return <div className="alerta alerta--erro">{erro}</div>;

  return (
    <>
      <h1>Uso e ocupacao</h1>
      <p className="suave pequeno" style={{ marginTop: "calc(-1 * var(--e-md))" }}>
        Instancias sao o PICO por maquina nos ultimos 30 dias, nao o valor corrente.
        O limite da licenca vale por aplicacao aberta, entao somar entre maquinas
        inventaria um excesso que o token nao impoe.
      </p>

      <div className="tiles">
        {v.tiles.map((t) => (
          <div key={t.rotulo} className={`tile${t.alerta ? " tile--alerta" : ""}`}>
            <div className="tile__valor">{t.valor}</div>
            <div className="tile__rotulo">{t.rotulo}</div>
            <div className="tile__sub">{t.sub}</div>
          </div>
        ))}
      </div>

      <Cartao titulo="Licencas ativas" pergunta="ordenadas pela ocupacao mais apertada primeiro">
        {v.linhas.length === 0 ? <Vazio titulo="Nenhuma licenca ativa" /> : (
          <div className="tabela-rolagem">
            <table className="tabela">
              <thead>
                <tr>
                  <th>Empresa</th><th>Licenca</th><th>Vagas</th><th>Instancias (pico 30 d)</th>
                  <th>Pico historico</th><th>Validade</th><th>Sem contato</th><th>Ultimo sinal</th>
                </tr>
              </thead>
              <tbody>
                {v.linhas.map((l) => {
                  const acima = l.instancias_pico > l.instancias_total;
                  return (
                    <tr key={l.licenca_id}>
                      <td>{l.empresa}</td>
                      <td><Link to={`/licencas/${l.licenca_id}`}>{l.apelido || `Licenca ${l.licenca_id}`}</Link></td>
                      <td><MicroMedidor usado={l.vagas_usadas} total={l.vagas_total} /></td>
                      <td>
                        <MicroMedidor usado={l.instancias_pico} total={l.instancias_total} />
                        {acima && <Selo tom="critico">acima do contratado</Selo>}
                      </td>
                      <td className="pequeno suave">
                        {l.pico_historico}
                        {l.dia_do_pico && <span className="apagado"> em {data(l.dia_do_pico)}</span>}
                      </td>
                      <td className="pequeno">
                        {l.validade ? data(l.validade) : <span className="apagado">perpetua</span>}
                      </td>
                      <td>
                        {l.modo_offline === "bloquear"
                          ? <Selo tom="critico">bloqueia</Selo>
                          : <span className="apagado pequeno">so avisa</span>}
                      </td>
                      <td className="suave pequeno">{desde(l.ultimo_sinal)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </Cartao>
    </>
  );
}
